var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('List',{attrs:{"envInfoType":3,"envName":"生产环境"}})}
var staticRenderFns = []

export { render, staticRenderFns }